export default __webpack_public_path__ + "static/media/albergue-bl.b15f53ed.png";